import React, { useState, useEffect } from 'react'
import styles from "../styles/Home.module.scss";
import { downloadBuildboxClient } from "../utils/downloadUtils";
import { isMobile } from 'react-device-detect';
import { useMediaQuery } from 'react-responsive';

const PreviewSection = (props) => {
  const { backgroundImg, 
    headerText, 
    leftText,
  } = props;


  const [downloadUrl, setDownloadUrl] = useState("");


  useEffect(() => {
    const url = downloadBuildboxClient();
    setDownloadUrl(url);
  }, []);


  const isWideWidth = useMediaQuery({
    query: '(min-width: 1025px)'
  })

  const DesktopRender = () => {
    return (
      <div>
        {
          isWideWidth ? 
          <div className={styles.section} >
          <div className={styles.container}>
            <div className={styles.contentWrapper}>
              <div className={styles.dualContent}>
                <div className={styles.leftContent}>
                <div className={styles.items}>
                  <h1>{headerText}</h1>
                  <p className={styles.leftContentText}>{leftText.top}</p>
                  <p className={styles.leftContentText}>{leftText.bottom}</p>
                    <div className={styles.preorderBtnWrapper}>
                      <a
                        href={downloadUrl}
                      >
                        <img
                          className={styles.appstoreBtn}
                          src={leftText.btn1}
                          alt="Download Buildbox 3"
                        />
                      </a>
                      <a
                        href="https://signup.buildbox.com/product/bb3"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className={styles.appstoreBtn}
                          src={leftText.btn2}
                          alt="Learn More"
                        />
                      </a>
                  </div>
                </div>
                </div>
                <div className={styles.rightContent}>
                  <img className={styles.contentImage} src={backgroundImg} alt="build box 3" />
                </div>
              </div>
          
            </div>
          </div>
        </div>
        : 
        <div className={styles.previewWrapper}>
          <div className={styles.previewContent}>
            <div className={styles.items}>
              <h1>{headerText}</h1>
              <p className={styles.leftContentText}>{leftText.top}</p>
              <p className={styles.leftContentText}>{leftText.bottom}</p>
              <div className={styles.preorderBtnWrapper}>
                <a
                  href={downloadUrl}
                >
                  <img
                    className={styles.appstoreBtn}
                    src={leftText.btn1}
                    alt="Download Buildbox 3"
                  />
                </a>
                <a
                  href="https://signup.buildbox.com/product/bb3"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={styles.appstoreBtn}
                    src={leftText.btn2}
                    alt="Learn More"
                  />
                </a>
              </div>
            </div>

          </div>
          <div >
            <img className={styles.contentImage} src={backgroundImg} alt="build box 3" />
          </div>
        </div>
        }

      </div>

    )
  }


  const MobileRender = () => {
    return (
      <div className={styles.mobilePreview}>
        <div className={styles.mobileContainer}> 
         <div className={styles.mobileImgContainer}>
            <img className={styles.mobileImg} src={backgroundImg} alt="build box 3" />
         </div>
        </div>
        <div className={styles.mobileText}>
          <h1>{headerText}</h1>
          <p >{leftText.top}</p>
          <p >{leftText.bottom}</p>
            <a
              href="https://signup.buildbox.com/product/bb3"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={styles.appstoreBtn}
                src={leftText.btn2}
                alt="Learn More"
              />
            </a>
        </div>
      </div>
    )
  }
  return (
    <>
      {!isMobile && <DesktopRender/>}
      {isMobile && <MobileRender/>}
    </>
  )
  
}
export default PreviewSection
